namespace $ {

	/** Identity of the shipped compiler. Verified against the vendor bytes in tests. */
	export const $shm_hitalama_map_component_compiler_version = {
		version: '5.9.3',
		sha256: '3ae902c92cc44dace175c0e69e13a4b0899f6983c6121d76b9ab8dd5795e7675',
	} as const

}
